import { render, staticRenderFns } from "./InvolvementHeader.vue?vue&type=template&id=60985f2e&"
import script from "./InvolvementHeader.vue?vue&type=script&lang=js&"
export * from "./InvolvementHeader.vue?vue&type=script&lang=js&"
import style0 from "./InvolvementHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports